export const userNameSelector = (state) => {
    return state.login.currentUser.username
}